import { pinia } from "../pinia";
import { useFleetStore } from "./index";
/** Vuex planManager / usePlanManagerStore — filo okuma birincil kaynak Pinia (micro-6-4, 7-2) */
export function getFleetStore() {
    return useFleetStore(pinia);
}
/**
 * vehicleAssignment getter adları — Vuex state yerine Pinia delegate.
 * Yazma: Vuex commit + Pinia action paralel (FAZ 8'e kadar).
 */
export const fleetStoreGetters = {
    getVehicleAssignments: () => (vehicleId) => getFleetStore().getVehicleAssignments(vehicleId),
    getTotalVehicles: () => getFleetStore().getTotalVehicles,
};
